import { createApp } from "vue";
import App from "./App.vue";
import router from "./router";
import { setupPinia } from "./stores";
import ElementPlus from "element-plus";
import { ElEmpty } from "element-plus";
import * as ElementPlusIconsVue from "@element-plus/icons-vue";
import "element-plus/dist/index.css";
import locale from "element-plus/lib/locale/lang/zh-cn";
import {
  registerMicroApps,
  start,
  initGlobalState,
  MicroAppStateActions,
} from "qiankun";
import "@/assets/css/base.less";
import "@/assets/css/theme.less";
import ElUpload from "@/components/Upload.vue";
import { userStore } from "./stores/modules/user";
const provide = {
  install: (app: import("vue").App<any>) => {
    // const routerKey = "router" as unknown as InjectionKey<
    //   import("vue-router").Router
    // >;
    // app.provide("msg", ElMessage);
    // app.provide(routerKey, router);
    // app.provide("userState", userStore());
    // // console.log(router.push);
  },
};

// const state = { token: "11111" };
// // 初始化 state
// const actions: MicroAppStateActions = initGlobalState(state);
// actions.onGlobalStateChange((state, prev) => {
//   // state: 变更后的状态; prev 变更前的状态
//   console.log(state, prev);
// });
// actions.setGlobalState(state);
// actions.offGlobalStateChange();

const rewriteComponents = (instance: any) => {
  instance._context.components["ElUpload"] = ElUpload;

  ElEmpty.props.image.default = require("@/assets/img/icons/empty-icon.png");
  instance._context.components["ElEmpty"] = ElEmpty;
};

let app: any = null;

function render(props: any = {}) {
  const { container } = props;
  app = createApp(App);
  app.use(router);
  app.use(setupPinia);
  app.use(ElementPlus, { locale });
  app.use(provide);
  for (const [key, component] of Object.entries(ElementPlusIconsVue)) {
    app.component(key, component);
  }
  rewriteComponents(app);
  app.mount(container ? container.querySelector("#app") : "#app");
  app.config.performance = false;

  registerMicroApps([
    {
      name: "ieds",
      entry:
        process.env.NODE_ENV == "development"
          ? "http://192.168.0.157:8081/micro/"
          : "/micro/",
      container: "#qiankun_u",
      activeRule: "/micro-ieds",
      props: {
        userStore: userStore(),
      },
    },
  ]);
  start({
    sandbox: { experimentalStyleIsolation: false, strictStyleIsolation: false },
    // excludeAssetFilter: (url) => {
    //   console.log(url);
    //   return false;
    // },
    excludeAssetFilter: (url: string) => {
      console.log(url);
      return false;
    },
  });
}
// 独立运行时
render();
// if (!window.__POWERED_BY_QIANKUN__) {
// }

export const appInstance = app;

/**
 * bootstrap 只会在微应用初始化的时候调用一次，下次微应用重新进入时会直接调用 mount 钩子，不会再重复触发 bootstrap。
 * 通常我们可以在这里做一些全局变量的初始化，比如不会在 unmount 阶段被销毁的应用级别的缓存等。
 */
export async function bootstrap() {
  console.log("[vue] vue app bootstraped");
}

/**
 * 应用每次进入都会调用 mount 方法，通常我们在这里触发应用的渲染方法
 */
export async function mount(props: any) {
  console.log("[vue] props from main framework", props);
  render(props);
}

/**
 * 应用每次 切出/卸载 会调用的方法，通常在这里我们会卸载微应用的应用实例
 */
export async function unmount() {
  app.unmount();
  (<Element>app._container).innerHTML = "";
  app = null;
}

/**
 * 可选生命周期钩子，仅使用 loadMicroApp 方式加载微应用时生效
 */
export async function update(props: any) {
  console.log("update props", props);
}
